import {Injectable} from '@angular/core';
import {UILayout} from '../models/uiLayout';
import {UIParameter} from '../models/uiParameter';
import {UIWorkflowValidierung} from '../models/uiWorkflowValidierung';
import {UIAusrichtung} from '../models/uiAusrichtung';
import {KeycloakConfig, RuntimeContext} from '@lv1871/core';
import {VariantenvergleichData} from '../models/variantenvergleichData';


export class ShellParameter {
  showMenu: boolean = true;
  showWorkflowButtons: boolean = true;
  showEntwicklerleiste: boolean = true;
  runtimeContext: RuntimeContext = RuntimeContext.STANDALONE;
  uiLayout: UILayout;
  produktId: string;
  uiWorkflowValidierung: UIWorkflowValidierung;
  uiWorkflowStopBeiVotum: boolean;
  uiAusrichtung: UIAusrichtung;
  keycloakConfig: KeycloakConfig;
  uiVorgangId: string;
  internalRequest: boolean;
  variantenvergleich: boolean;
  variantenvergleichData: VariantenvergleichData;
};

@Injectable()
export class ShellConfigService {

  public static defaultParameter: ShellParameter = {
    showMenu: true,
    showWorkflowButtons: true,
    showEntwicklerleiste: true,
    uiLayout: UILayout.NAVIGATION_MENU,
    produktId: '',
    runtimeContext: RuntimeContext.STANDALONE,
    internalRequest: false,
    uiVorgangId: 'Antrag'
  } as ShellParameter;
  public shellParameter: ShellParameter = new ShellParameter();
  public designerParameter: UIParameter;

  public getParameter(): ShellParameter {
    const parameter = {...ShellConfigService.defaultParameter} as ShellParameter;
    if (!!this.shellParameter.uiLayout) {
      parameter.uiLayout = this.shellParameter.uiLayout;
    } else if (!!this.designerParameter?.UILayout) {
      parameter.uiLayout = this.designerParameter.UILayout;
    }
    if (!!this.shellParameter.uiAusrichtung) {
      parameter.uiAusrichtung = this.shellParameter.uiAusrichtung;
    } else if (!!this.designerParameter?.UIAusrichtung) {
      parameter.uiAusrichtung = this.designerParameter.UIAusrichtung;
    }
    if (!!this.shellParameter.uiWorkflowValidierung) {
      parameter.uiWorkflowValidierung = this.shellParameter.uiWorkflowValidierung;
    } else if (!!this.designerParameter?.UIWorkflowValidierung) {
      parameter.uiWorkflowValidierung = this.designerParameter.UIWorkflowValidierung;
    }
    if (!!this.shellParameter.uiWorkflowStopBeiVotum) {
      parameter.uiWorkflowStopBeiVotum = this.shellParameter.uiWorkflowStopBeiVotum;
    } else {
      parameter.uiWorkflowStopBeiVotum = this.designerParameter?.UIWorkflowStopBeiVotum;
    }
    parameter.showMenu = this.shellParameter.showMenu;
    parameter.showWorkflowButtons = this.shellParameter.showWorkflowButtons;
    if (this.shellParameter.showEntwicklerleiste !== undefined) {
      parameter.showEntwicklerleiste = this.shellParameter.showEntwicklerleiste;
    }
    if (!!this.shellParameter.runtimeContext) {
      parameter.runtimeContext = this.shellParameter.runtimeContext;
    } else {
      parameter.runtimeContext = RuntimeContext.STANDALONE;
    }
    if (!!this.shellParameter.produktId) {
      parameter.produktId = this.shellParameter.produktId;
    }
    if (this.shellParameter.internalRequest !== undefined) {
      parameter.internalRequest = this.shellParameter.internalRequest;
    }
    if (!!this.shellParameter.keycloakConfig) {
      parameter.keycloakConfig = this.shellParameter.keycloakConfig;
    }
    if (!!this.shellParameter.uiVorgangId) {
      parameter.uiVorgangId = this.shellParameter.uiVorgangId;
    }
    return parameter;
  }

}
